var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0026 10.6663C13.0559 10.6663 10.6693 13.053 10.6693 15.9997C10.6693 18.9463 13.0559 21.333 16.0026 21.333C18.9493 21.333 21.3359 18.9463 21.3359 15.9997C21.3359 13.053 18.9493 10.6663 16.0026 10.6663ZM27.9226 14.6663C27.3093 9.10634 22.8959 4.69301 17.3359 4.07967V1.33301H14.6693V4.07967C9.10927 4.69301 4.69594 9.10634 4.0826 14.6663H1.33594V17.333H4.0826C4.69594 22.893 9.10927 27.3063 14.6693 27.9197V30.6663H17.3359V27.9197C22.8959 27.3063 27.3093 22.893 27.9226 17.333H30.6693V14.6663H27.9226ZM16.0026 25.333C10.8426 25.333 6.66927 21.1597 6.66927 15.9997C6.66927 10.8397 10.8426 6.66634 16.0026 6.66634C21.1626 6.66634 25.3359 10.8397 25.3359 15.9997C25.3359 21.1597 21.1626 25.333 16.0026 25.333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLocation);
export default __webpack_public_path__ + "static/media/my_location.da5d65033d18ceadf4cc8da8f7917aa5.svg";
export { ForwardRef as ReactComponent };